export default {
  title: 'Keskeytä saatavuus',
  description: 'Täyteen varattu?',
  pause_availabilities: {
    pause_until_end_of_day: 'Keskeytetäänkö varaukset päivän loppuun asti?',
    pause_specific_time: 'Keskeytä varaukset toiselle päivälle ja/tai ajalle',
  },
  pause_reservations_today: 'Keskeytä tämän päivän varaukset',
  pause_reservations_another_day: 'Keskeytä varaukset toiselle päivälle',
  paused_availabilities_form: {
    date_time: {
      label: 'Valitse päivämäärä ja aika',
    },
    reason: {
      label: 'Lisää syy (valinnainen)',
      placeholder: 'Kirjoita kuvaus...',
    },
  },
  buttons: {
    save: 'Tallenna',
  },
  error_messages: {
    creation_failed: 'Poikkeuksen luominen epäonnistui',
  },
};
